import { call, put, takeLatest } from "redux-saga/effects";
import { getAllClassSubjectMappingRequest, getAllClassSubjectMappingSuccess } from "./classSubjectMappingSlice";
import { getAllClassSubjectMapping } from "../../api/ClassSubjectMapping/GetAllClassSubjectMappingListService";

function* fetchClassSubjectMappingSaga(action) {
  try {
    const { formData } = action.payload;
    const response = yield call(getAllClassSubjectMapping, formData);
    yield put(getAllClassSubjectMappingSuccess(response?.data)); 
  } catch (error) {
    yield put(getAllClassSubjectMappingSuccess([])); 
    // yield put(getClassPeriodsFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassSubjectMapping() {
  yield takeLatest(getAllClassSubjectMappingRequest.type, fetchClassSubjectMappingSaga);
}

